<div class="component-wrapper">
    <form [formGroup]="contactDataForm">
        <div>
            <section-info ></section-info>
    
            <institution class="institution-input" [form]="contactDataForm.Institution"
                [disabled]="false"></institution>
        </div>
        <div>
            <h1 class="form-title" translate>contact-data.contactPersonTitle</h1>
            <kontakt class="ansprechpartner-input" [form]="contactDataForm.Ansprechpartner" kontakttyp="ansprechpartner" [isRequired]="true" [isWeitererAnsprechpartnerChecked]="weitererAnsprechpartnerChecked"
               ></kontakt>

            <div class="mt-4">
                <kendo-formfield class="cbweitererAnsprechpartner">
                    <div class="k-checkbox-wrap">
                        <input id="cbweitererAnsprechpartner" #cbweitererAnsprechpartner type="checkbox" kendoCheckBox
                            formControlName="cbweitererAnsprechpartner" [attr.aria-label]="'contact-data.additionalContactPersonTitle' | translate" />
                        <label for="cbweitererAnsprechpartner"
                            class="k-checkbox-label ansprechpartner3-heading" [attr.aria-label]="'contact-data.additionalContactPersonTitle' | translate" translate>
                            contact-data.additionalContactPersonTitle
                        </label>
                    </div>
                </kendo-formfield>
                <div *ngIf="cbweitererAnsprechpartner.checked" class="ansprechpartner2 mt-3">
                    <kontakt class="ansprechpartner2-input" [form]="contactDataForm.WeitererAnsprechpartner"
                        kontakttyp="weitereransprechpartner" [isWeitererAnsprechpartnerChecked]="weitererAnsprechpartnerChecked">
                    </kontakt>
                </div>
            </div>
        </div>
        <div>
            <div>
                <h1 class="form-title" translate>
                    contact-data.authorizedRepresentative
                    <h2 class="heading-description" translate>
                        contact-data.authorizedRepresentativeDescription
                    </h2>
                </h1>
            </div>
            <kontakt class="vertretungsberechtigter-input" [form]="contactDataForm.Vertretungsberechtigter"
                kontakttyp="vertretungsberechtigter" [isWeitererAnsprechpartnerChecked]="weitererAnsprechpartnerChecked"></kontakt>

            <div class="mt-4">
                <kendo-formfield class="cbweitererVertretungsberechtigter">
                    <div class="k-checkbox-wrap">
                        <input id="cbweitererVertretungsberechtigter" #cbweitererVertretungsberechtigter type="checkbox" kendoCheckBox
                            formControlName="cbweitererVertretungsberechtigter" />
                        <label id="cbweitererVertretungsberechtigter" for="cbweitererVertretungsberechtigter"
                            class="k-checkbox-label vertretungsberechtigter3-heading" translate>
                            contact-data.additionalAuthorizedRepresentative
                        </label>
                    </div>
                </kendo-formfield>
                <div *ngIf="cbweitererVertretungsberechtigter.checked" class="vertretungsberechtigter2 mt-3">
                    <kontakt class="vertretungsberechtigter2-input" [form]="contactDataForm.WeitererVertretungsberechtigter"
                       kontakttyp="weitererVertretungsberechtigter" [isWeitererAnsprechpartnerChecked]="weitererAnsprechpartnerChecked"></kontakt>
                </div>
            </div>
        </div>
        <kendo-formfield class="informationsquelle">
            <kendo-label class="form-label" [for]="informationsquelle" text="{{'contact-data.informationSourceText' | translate}} *" [infotooltip]="'kontaktdaten.informationsquelle'"></kendo-label>
            <kendo-combobox formControlName="informationsquelle" [valuePrimitive]="true" #informationsquelle
                [allowCustom]="false" [data]="informationsquelleList" [valueField]="'Value'"
                [textField]="'Description'" [appinfotext]="'kontaktdaten.informationsquelle'" kendoDropDownFilter>
            </kendo-combobox>
        </kendo-formfield>
    </form>
</div>